import React, { useEffect, useState } from "react";
import DivisionCmp from "../../../components/cards/DivisionCmp";

import DetailInfoComponent from "../../../components/detailInfo/detailInfoComponent";
import { SectionModel } from "../../../models/components.model";
import { ChequeGuarantyInfo } from "../../../models/loan.model";
import DocumentInfoComponent from "../../../components/detailInfo/documentInfoComponent";
import { InfoCheque } from "../../../models/cartable.model";
import DocumentInfoComponentSingle from "../../../components/detailInfo/documentInfoComponentSingle";
import { string } from "prop-types";

interface SchemaInfoModel {
    data?: InfoCheque;
}
function _VehicleExpert(props: any) {
    const sections: SectionModel[] = [
        {
            dataKey: "fullName",
            rowCol: 3,
            title: "نام و نام خانوادگی کارشناس",
        },
        {
            dataKey: "nationalCode",
            rowCol: 3,
            title: "کد ملی",
        },
        {
            dataKey: "mobileNumber",
            rowCol: 3,
            title: "شماره موبایل",
        },
        {
            dataKey: "estimatedPrice",
            rowCol: 3,
            title: "مبلغ کارشناسی شده خودرو ",
            dataPostValue: "ریال",
            hasThousandSeparatorFormat: true,
        },
        {
            dataKey: "cityTitle",
            rowCol: 3,
            title: "شهر ",
        },
        {
            dataKey: "address",
            rowCol: 3,
            title: "آدرس",
        },

    ];

    return (
        <DetailInfoComponent
            sections={sections}
            data={props.data}
            documentInfo={props.data!.file ? props.data!.file : props.data!.documents[0]}
            showFooter={false}
            showDoc={props.withoutDoc}
        />
    );
}

export default function VehicleExpert(props: any) {
    const child = (
        <>
            {" "}
            <_VehicleExpert data={props.data} withoutDoc={props.withoutDoc} />
            {/* <DocumentInfoComponentSingle data={data?.file} /> */}
        </>
    );
    return <DivisionCmp child={child} title={"جزییات کارشناسی خودرو"} />;
}
